import { makeAssertNamespace } from './assert';
import { makeLogNamespace } from './log';

export const makeNamespacedLog = (logNamespace: string) => ({
  assert: makeAssertNamespace(logNamespace),
  ...makeLogNamespace(logNamespace),
});
